import React, { useState } from "react";
import "./HoverTooltip.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { speakerStyles } from "../../../../utils/speakerStyle";
import SpeakerSegments from "./SpeakerSegment";

interface HoverTooltipProps {
  duration: number;
  currentTime: number;
  seekAudio: (e: number) => void;
}

const HoverTooltip: React.FC<HoverTooltipProps> = ({ duration, currentTime, seekAudio }) => {
  const speakers = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].speakers) as string[];
  const transcriptions = useSelector((state: RootState) => state.qCDetailPageState.data.transcriptions[0].transcriptionBlocks);

  const [hoverTime, setHoverTime] = useState<number | null>(null);
  const [hoverPercent, setHoverPercent] = useState<number>(0);
  const [tooltipPosition, setTooltipPosition] = useState<{ left: number; top: number }>({ left: 0, top: 0 });
  const currentTimePercent = (currentTime / duration) * 100;

  const handleMouseMove = (e: React.MouseEvent<HTMLInputElement>) => {
    const { left, width, top } = e.currentTarget.getBoundingClientRect();
    const percent = (e.clientX - left) / width;
    setHoverTime(percent * duration);
    setTooltipPosition({ left: e.clientX - 120, top: top - 30 }); // Adjust the top value to position the tooltip above the slider
    setHoverPercent(percent * 100);
  };

  return (
    <div className="progress-time w-100">
      <div
        className="hover-background"
        style={{
          width: `${hoverPercent}%`,
        }}></div>
      <div
        className="current-time"
        style={{
          width: `${currentTimePercent}%`,
        }}
      />
      <div
        className="time-indicator"
        onMouseMove={handleMouseMove}
        onClick={() => {
          if (hoverTime !== null) {
            seekAudio(hoverTime);
          }
        }}
        onMouseLeave={() => {
          setHoverTime(null);
          setHoverPercent(0);
        }}
      />
      {hoverTime !== null && (
        <div
          className="custom-tooltip"
          style={{
            left: tooltipPosition.left,
          }}>
          {new Date(hoverTime * 1000).toISOString().substr(11, 8)}
        </div>
      )}

      <SpeakerSegments
        transcriptions={transcriptions}
        speakers={speakers}
        speakerStyles={speakerStyles}
        duration={duration}
      />
    </div>
  );
};

export default HoverTooltip;
